import cx from "classnames";
import Icon from "@/atoms/Icon";
import PropTypes from "prop-types";
import styled, { keyframes } from "styled-components";
import tw from "twin.macro";

const pulse = keyframes`
  0%,
  40%,
  100% {
    opacity: 0.5;
  }
  20% {
    opacity: 1;
  }
`;

const StyledIcon = styled(Icon)`
  animation: 1s ${pulse} cubic-bezier(0.4, 0, 0.6, 1) infinite;
  &:nth-of-type(1) {
    animation-delay: 0ms;
  }
  &:nth-of-type(2) {
    animation-delay: 175ms;
  }
  &:nth-of-type(3) {
    animation-delay: 350ms;
  }
`;

const StyledLoadingAnimation = styled.div`
  ${tw`flex items-center justify-center`}
  animation: 0.2s fadeIn ease forwards;
  z-index: 1000;

  &.as-overlay {
    ${tw`h-full w-full fixed inset-0`}
    background: rgba(255, 255, 255, 0.85);
  }

  .content {
    ${tw`text-center`}
  }
`;

/**
 * @param {Object} props
 * @param {String} [props.message]
 * @param {Boolean} [props.inline]
 * @param {String} [props.className]
 */
const LoadingAnimation = ({ message, inline = false, className = "" }) => (
  <StyledLoadingAnimation
    className={cx("loading-animation", className, { "as-overlay": !inline })}
  >
    <div className={"content"}>
      <div className={"icons"}>
        <StyledIcon
          name={"circle-solid"}
          size={"40px"}
          fill={"#FCDC87"}
          className={"icon mr-8"}
        />
        <StyledIcon
          name={"triangle-solid"}
          size={"46px"}
          fill={"#F4B4A6"}
          className={"icon mr-8"}
        />
        <StyledIcon
          name={"square-solid"}
          size={"40px"}
          fill={"#B0D5E6"}
          className={"icon"}
        />
      </div>
      {message && <div className={"text-xl mt-4 mb-12"}>{message}</div>}
    </div>
  </StyledLoadingAnimation>
);

LoadingAnimation.propTypes = {
  message: PropTypes.string,
  inline: PropTypes.bool,
};

export default LoadingAnimation;
